module.exports = __webpack_public_path__ + "img/user_default.710f7f23.png";